import axios from "axios"
import { toast } from "react-toastify"

const fetchCompaniesProfilePublishRequest = () => {
	return {type: "FETCH_COMPANIESPROFILE_PUBLISH_REQUEST"}
}

const fetchCompaniesProfilePublishSuccess = (company) => {
	return {type: "FETCH_COMPANIESPROFILE_PUBLISH_SUCCESS", payload: company}
}

const fetchCompaniesProfilePublishFailure = (error) => {
	return {type: "FETCH_COMPANIESPROFILE_PUBLISH_FAILURE", payload: error}
}

export const fetchCompaniesPublish = (id) => {
	return (dispatch) => {
		dispatch(fetchCompaniesProfilePublishRequest())
        axios.post(`admin/user/publish/${id}`)
		.then(response => {
			const companies = response.data
			dispatch(fetchCompaniesProfilePublishSuccess(companies))
			toast.dismiss()	
			toast.success("با موفقیت انجام شد" , {position: 'bottom-right',className: 'foo-bar'})
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchCompaniesProfilePublishFailure(error))
			toast.dismiss()
			toast.error("مشکلی پیش آمده است" , {position: 'bottom-right',className: 'foo-bar'})		
		})
	}
}